import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import {
  createReservedPurchase,
  PaymentFlow,
} from "@/features/payment-flow/payment-flow";

// The whole purchase of a washer or dryer, from choosing the machine to the
// start guide, in one component (replaces machine-selector-screen →
// dryer-bundle-selector-screen → payment-selector-screen → card / cash /
// balance screen → payment-complete → wash-start-guide). Used instead of those
// screens while the `washStartGuide` flag is on.
export const Route = createFileRoute("/payment/$machineType")({
  component: RouteComponent,
  params: {
    parse: (params) =>
      z
        .object({
          machineType: z.enum(["drying-machines", "washing-machines"]),
        })
        .parse(params),
  },
  // set by the reservations screen: that machine is already chosen
  validateSearch: z.object({
    machineId: z.coerce.number().optional().catch(undefined),
  }),
  loaderDeps: ({ search }) => ({ machineId: search.machineId }),
  // the screens after the flow ("start another machine") read it
  beforeLoad: ({ params }) => {
    sessionStorage.setItem("machine-type", params.machineType);
  },
  loader: async ({ deps }) => {
    if (!deps.machineId) return { reservedPurchase: null };
    try {
      return { reservedPurchase: await createReservedPurchase(deps.machineId) };
    } catch (error) {
      // like the old payment screens: no payment, start over
      console.error(error);
      throw redirect({ to: "/start-screen", reloadDocument: true });
    }
  },
});

function RouteComponent() {
  const params = Route.useParams();
  const { reservedPurchase } = Route.useLoaderData();
  return (
    <PaymentFlow
      kind={params.machineType === "drying-machines" ? "dryer" : "washer"}
      reservedPurchase={reservedPurchase}
    />
  );
}
